export default __webpack_public_path__ + "static/media/5h.5a9509d3.png";